import * as MakeBetActions from 'actions/MakeBet';

export default function alternativeStakeReducer(alternativeStake, action) {
    switch (action.type) {
        case MakeBetActions.SUCCESS_MAKE_BET:
            const createdBets = action.data;

            for (let offset = 0; offset < createdBets.length; offset++) {
                const createdBet = createdBets[offset];

                if (createdBet.error !== undefined && createdBet.error) {
                    if(createdBet.error === -18){
                        return createdBet.alternativeStake
                    } else {
                        return null
                    }
                }
            }
    }

    return null;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/coupon/alternativeStakeReducer.js